import {
    Exercise, Level, Phase,
    ScheduleEntryColourCode, SessionSequence, WorkoutSettings,
} from '../../../entities';
import { Delays } from '../../../entities/exercise/delays';
import { ISessionSequenceStrategy } from '../isessionsequencestrategy';

export class HomeBuildQuarterSetup implements ISessionSequenceStrategy {
    public getVoiceTipsDelays = () => new Delays(NaN, NaN, NaN, NaN);
    public getSessionSequence(
        exercise: Exercise,
        alernativeExercise: Exercise,
        secondAternativeExercise: Exercise,
        thirdAlternateExercise: Exercise,
        zone: number,
        quarter: number,
        level: Level | undefined,
        workoutSettings: WorkoutSettings | undefined,
    ): SessionSequence[] {
        const duration = 0;
        return [{
            durationInMilliseconds: duration,
            sequence: [{
                durationInMilliseconds: duration,
                videoFile: exercise.uniqueReferenceNumber,
                exerciseVersion: exercise._rev,
                displayName: exercise.name,
                displayBurnOrBuildIcon: true,
                progressColourCode: ScheduleEntryColourCode.Rest,
                progressText: 'Start in {seconds}',
                showProcessedMetrics: false,
                showCalculatedMetrics: true,
                tips: [],
                zone,
                quarter,
                phase: Phase.Rest,
            }],
        }];
    }
}
